import { FC } from "react";
import PrivacyPolicy from "@/components/BlankPages/PrivacyPolicy";
import Container from "@/components/Container";

// import useMediaQuery from "@/custom_hooks/mediaQuery";
// import cx from 'classnames';

const PrivacyPolicys: FC = () => {
  return (
    <div className="flex flex-col bg-white px-4">
      <Container>
        <PrivacyPolicy />
      </Container>
    </div>
  );
};
export default PrivacyPolicys;
